import React, {useEffect} from 'react';
import '../assets/templates/PrePost.css';
import {getVideoUrl, isEmpty} from "../lib/utils";
import useVideoPlayback from "../hooks/useVideoPlayback";

const PrePost = ({ blockData }) => {

    // const {togglePlay, overridePlayAction, isLessonPlaying, next} = useLessonNavigation();
    const {vimeoBuilder, cleanup} = useVideoPlayback(getVideoUrl(blockData.videoId),  'pre_post')

    const VimeoComponent = vimeoBuilder({ responsive: true});

    useEffect(() => {
        return () => {
            cleanup();
        }
    }, []);

    return (
        <>
            <div className="default-card">
                <div className='prepost-container-video'>
                    {!blockData.loading ? (
                        !isEmpty(blockData.videoId) ? (
                            <div>
                                {VimeoComponent}
                            </div>
                        ) : (
                            <div>No video available</div>
                        )
                    ) : (
                        <div>Loading...</div>
                    )}
                </div>
            </div>
        </>
    );
}

export default PrePost;
